import { render, staticRenderFns } from "./IconSectionHeader.vue?vue&type=template&id=b40e5108&"
import script from "./IconSectionHeader.vue?vue&type=script&lang=js&"
export * from "./IconSectionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b40e5108')) {
      api.createRecord('b40e5108', component.options)
    } else {
      api.reload('b40e5108', component.options)
    }
    module.hot.accept("./IconSectionHeader.vue?vue&type=template&id=b40e5108&", function () {
      api.rerender('b40e5108', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSectionHeader.vue"
export default component.exports